import type React from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

type Props = {
    title: string;
    infoTooltip?: string;
};

const CardHeader: React.FC<Props> = ({ title, infoTooltip }) => {
    return (
        <Flex
            padding="20px 24px 19px"
            borderBottom={`1px solid ${colorsPalettes.carbon["100"]}`}
            borderRadius="6px 6px 0 0"
            height="63px"
            alignItems="center"
            gap="8px"
        >
            <Text
                fontVariant="h5"
                color={colorsPalettes.carbon[500]}
            >
                {title}
            </Text>
            {infoTooltip ? (
                <PlainTooltip
                    maxWidth="230px"
                    tooltipContent={infoTooltip}
                >
                    <div>
                        <SWReactIcons
                            iconName="info"
                            size="xs"
                        />
                    </div>
                </PlainTooltip>
            ) : null}
        </Flex>
    );
};

export default CardHeader;
